import React from 'react';
import { RefreshCwIcon } from 'lucide-react';
type CurrencyNoteProps = {
  tone?: 'light' | 'dark';
};
export function CurrencyNote({
  tone = 'light'
}: CurrencyNoteProps) {
  const isDark = tone === 'dark';
  return <p className={`flex max-w-xl items-start gap-2 rounded-xl px-4 py-3 text-left text-[13px] leading-snug ${isDark ? 'bg-white/10 text-white/85' : 'bg-mist text-ink/75'}`} data-id="element-34" data-mp="194ugciziag72">
      <RefreshCwIcon className={`mt-0.5 h-4 w-4 shrink-0 ${isDark ? 'text-gold' : 'text-electric'}`} aria-hidden="true" data-id="element-35" data-mp="10463hrlumlvr" />
      <span data-id="element-36" data-mp="147vpc9b52pd3">
        <strong className={isDark ? 'text-white' : 'text-ink'} data-id="element-37" data-mp="1447tv4m4vsvq">Automatic currency conversion.</strong> All prices are in USD —
        your payment provider converts the $27 to your local currency at checkout.
      </span>
    </p>;
}